import { FC, ComponentPropsWithoutRef } from 'react';
import classNames from 'classnames';
import { Panel, Headding as _Headding, Item as _Item } from './PrimaryPanel';
import styles from './SubPanel.scss';

export const SubPanel: FC<ComponentPropsWithoutRef<typeof Panel>> = ({ className, children, ...rest }) => (
  <Panel {...rest} className={classNames(styles.subPanel, className)}>
    {children}
  </Panel>
);

export const SubHeadding: FC<ComponentPropsWithoutRef<typeof _Headding>> = ({ children, ...rest }) => (
  <_Headding {...rest} className={styles.subHeadding}>
    {children}
  </_Headding>
);

export const SubItem = _Item;
